const normalizeOptionKey = (key: unknown): string | undefined => {
  if (typeof key === "string") {
    return key
  }

  if (typeof key === "number" && Number.isFinite(key)) {
    return String(key)
  }

  if (key && typeof key === "object") {
    if (typeof (key as any).name === "string") {
      return (key as any).name
    }
    if (typeof (key as any).title === "string") {
      return (key as any).title
    }
    if (typeof (key as any).id === "string") {
      return (key as any).id
    }
    if (typeof (key as any).id === "number" && Number.isFinite((key as any).id)) {
      return String((key as any).id)
    }
    if (typeof (key as any).option_id === "string") {
      return (key as any).option_id
    }
    if (typeof (key as any).option_id === "number" && Number.isFinite((key as any).option_id)) {
      return String((key as any).option_id)
    }
  }

  return undefined
}

const assignIfValid = (
  target: Record<string, string>,
  key: unknown,
  value: unknown
) => {
  if (typeof value !== "string" || value.length === 0) {
    return
  }

  const normalizedKey = normalizeOptionKey(key)
  if (!normalizedKey) {
    return
  }

  target[normalizedKey] = value
}

export const buildVariantOptionValues = (variant: any) => {
  if (!variant || typeof variant !== "object") {
    return undefined
  }

  if (variant.optionValues && typeof variant.optionValues === "object") {
    const optionValues: Record<string, string> = {}
    for (const [key, value] of Object.entries(variant.optionValues)) {
      if (typeof value === "string" && value.length > 0) {
        optionValues[key] = value
      }
    }
    return Object.keys(optionValues).length ? optionValues : undefined
  }

  if (Array.isArray(variant.options)) {
    const optionValues: Record<string, string> = {}

    variant.options.forEach((opt: any) => {
      const key =
        opt?.option_name ??
        opt?.name ??
        opt?.title ??
        opt?.id ??
        opt?.option_id ??
        opt?.optionId ??
        opt?.option?.id ??
        opt?.option?.title ??
        opt?.option?.name

      const value = opt?.option_value ?? opt?.value ?? opt?.option?.value
      assignIfValid(optionValues, key, value)
    })

    return Object.keys(optionValues).length ? optionValues : undefined
  }

  if (Array.isArray(variant.option_values)) {
    const optionValues: Record<string, string> = {}

    variant.option_values.forEach((opt: any) => {
      const key =
        opt?.option_id ??
        opt?.option?.id ??
        opt?.option?.title ??
        opt?.option?.name ??
        opt?.title ??
        opt?.name

      const value = opt?.value ?? opt?.option_value
      assignIfValid(optionValues, key, value)
    })

    return Object.keys(optionValues).length ? optionValues : undefined
  }

  return undefined
}

export const extractVariantOptionValues = (variant: any) => {
  const values = buildVariantOptionValues(variant)
  return values && Object.keys(values).length ? values : undefined
}
